const SAMPLE_QUESTIONS = [
  'What insight types most reliably lead to changed teacher behavior?',
  'What sequencing and pacing of insight delivery best supports teacher habit formation?',
  'Which UI/UX configurations reduce teacher overwhelm while maintaining insight richness?',
  'How does teacher annotation or editing of model-generated insights affect student outcomes?',
  'Can early model signals from student work predict teacher needs—not just student needs?',
  'What kinds of comparison data (e.g., peer norms, past assignments, district trends) increase action without increasing shame or distrust?',
  'How does visibility into micro-trends across classrooms shift how teachers plan for equity?',
  'What conditions make formative feedback use more sustainable across a full school year?',
  'What types of insights are most impactful for new teachers vs. experienced ones?',
  'Why was there a difference between course grades, exit tickets, etc.? Is it related to bias?'
];

const SampleQuestions = () => {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-md">
      <h1 className="mb-4 text-xl font-bold text-gray-900">
        Sample Research Questions
      </h1>
      <ul className="list-inside list-decimal space-y-2 text-gray-800">
        {SAMPLE_QUESTIONS.map((question, index) => (
          <li key={index} className="text-base leading-relaxed">
            {question}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SampleQuestions;
